import { INSERT, SELECT } from "@/utils/database_module"
import { ConflictStatus } from "@/utils/types"

const conflictsStatuses = {
    getAll : async () => {
        const conflict_statuses = await SELECT("conflict_status" , { }) as ConflictStatus[]
        return conflict_statuses
    },

    insert : async (status : any) => {
        return await INSERT("conflict_status" ,status)
    },


}

export default conflictsStatuses